// extracted by mini-css-extract-plugin
module.exports = {"locationsList":"UserManagement_locationsList__3JnP8","locationDetails":"UserManagement_locationDetails__1HZcj","roleDetails":"UserManagement_roleDetails__3iR6D"};